import React from "react";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import { Clock, AlertCircle, Star, Share2 } from "lucide-react";
import { format } from "date-fns";
import { ShareDialog } from "@/components/share/share-dialog";
import { Button } from "@/components/ui/button";

export function TaskCard({ task, onToggleComplete, onClick }) {
  return (
    <Card 
      className={cn(
        "transition-all hover:shadow-md cursor-pointer border-l-4",
        task.isCompleted ? "opacity-60 border-l-gray-300" : 
        task.isUrgent && task.isImportant ? "border-l-red-500" :
        task.isUrgent ? "border-l-orange-400" :
        task.isImportant ? "border-l-blue-500" : "border-l-green-400"
      )}
      onClick={() => onClick && onClick(task)}
    >
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          <Checkbox 
            checked={task.isCompleted} 
            onCheckedChange={(checked) => onToggleComplete(task.id, checked)}
            onClick={(e) => e.stopPropagation()}
            className="mt-1"
          />
          <div className="flex-1 space-y-1">
            <div className="flex items-center justify-between">
              <h4 className={cn("font-medium leading-none", task.isCompleted && "line-through text-muted-foreground")}>
                {task.title}
              </h4>
              <div className="flex gap-1">
                {task.isUrgent && <AlertCircle className="h-3 w-3 text-red-500" />}
                {task.isImportant && <Star className="h-3 w-3 text-yellow-500" />}
              </div>
            </div>
            <p className="text-sm text-muted-foreground line-clamp-2">
              {task.description}
            </p>
            
            <div className="flex items-center justify-between pt-2">
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                {task.dueDate && (
                  <div className="flex items-center gap-1">
                    <Clock className="h-3 w-3" />
                    <span>{format(new Date(task.dueDate), "MMM d, HH:mm")}</span>
                  </div>
                )}
                <Badge variant="secondary" className="text-[10px] h-5 px-1">
                  {task.xpReward} XP
                </Badge>
              </div>
              
              <div onClick={(e) => e.stopPropagation()}>
                <ShareDialog 
                  itemId={task.id} 
                  type="task" 
                  trigger={
                    <Button variant="ghost" size="icon" className="h-6 w-6">
                      <Share2 className="h-3 w-3" />
                    </Button>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
